import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

//import { TreeNode } from 'primeng/api';

import { Downloads } from '../../shared/services/downloads';
import { Applications } from '../../shared/services/applications';
import { Shareholder } from '../../shared/services/shareholder';
import { PolicyDocuments } from '../../shared/services/policy-documents';
import { Note } from '../../shared/services/note';

@Injectable()
export class NodeService {

    constructor(private http: HttpClient) { }

    getDownloads() {
        return this.http.get<any>('../assets/data/downloads.json')
            .toPromise()
            .then(res => <Downloads[]>res.data);
    }

    getApplicationsPending() {
        return this.http.get<any>('../assets/data/applications-pending.json')
            .toPromise()
            .then(res => <Applications[]>res.data);
    }

    getApplicationsCallback() {
        return this.http.get<any>('../assets/data/applications-callback.json')
            .toPromise()
            .then(res => <Applications[]>res.data);
    }

    getApplicationsResolved() {
        return this.http.get<any>('../assets/data/applications-resolved.json')
            .toPromise()
            .then(res => <Applications[]>res.data);
    }

    getShareholderDetails() {
        return this.http.get<any>('../assets/data/shareholder-details.json')
            .toPromise()
            .then(res => <Shareholder[]>res.data);
    }

    getPolicyDocuments() {
        return this.http.get<any>('../assets/data/policy-documents.json')
            .toPromise()
            .then(res => <PolicyDocuments[]>res.data);
    }

    getNotes() {
        return this.http.get<any>('../assets/data/note.json')
            .toPromise()
            .then(res => <PolicyDocuments[]>res.data);
    }

    getAuditHistory() {
        return this.http.get<any>('../assets/data/audit-history.json')
            .toPromise()
            .then(res => <PolicyDocuments[]>res.data);
    }
}
